import * as React from "react";
import { isEmpty } from "lodash-es";
import { EventResourceView } from "api/events/event.types";

type Props = {
  documents: EventResourceView[];
};

export const EventDocumentsList: React.FC<Props> = ({ documents }) => (
  <div>
    <ul className="list-unstyled">
      {isEmpty(documents)
        ? ""
        : documents.map((document, index) => (
            <li key={index}>
              <a href={`${document.resourceUrlAndHeader.url}?clientApp=ic`}>{document.fileName}</a>
            </li>
          ))}
    </ul>
  </div>
);
